var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { useEffect, useState } from 'react';
import { loadFull } from 'tsparticles'; // Or a specific preset like tsParticles.loadFull(engine)
import { particlesOptions } from './particles';
const Stars = () => {
    const [init, setInit] = useState(false);
    useEffect(() => {
        initParticlesEngine((engine) => __awaiter(void 0, void 0, void 0, function* () {
            // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
            // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
            // starting from v2 you can add only the features you need reducing the bundle size
            //await loadAll(engine);
            //await loadFull(engine);
            yield loadFull(engine);
            //await loadBasic(engine);
        })).then(() => {
            setInit(true);
        });
    }, []);
    // const particlesLoaded = useCallback(async (container: Container | undefined) => {
    //   await console.log(container);
    // }, []);
    return (_jsx(Particles, { id: "tsparticles", 
        //   init={particlesInit}
        // loaded={particlesLoaded}
        options: particlesOptions }));
};
export default Stars;
